
import { getSignDirection } from '@/utils/helpers';
import ControlPanelCircular from '@/components/control-panel/ControlPanelCircular.vue';
import ControlPanelIcon from '@/components/control-panel/ControlPanelIcon.vue';
import ControlPanelCard from '@/components/control-panel/ControlPanelCard.vue';
import ControlPanelLinear from '@/components/control-panel/ControlPanelLinear.vue';
import ControlItemContextMenu from '@/components/contextMenu/controlItemContextMenu.vue';

export default {
  name: 'AddFastCommandControlPanel',
  components: {
    ControlItemContextMenu,
    ControlPanelCircular,
    ControlPanelIcon,
    ControlPanelCard,
    ControlPanelLinear,
  },
  props: {
    deviceInfo: {
      required: true,
      type: Object,
    },
    deviceId: {
      required: true,
      type: Number,
    },
  },
  data: () => ({
    setTimer: false,
    showSettings: false,
    deviceInfoSaveState: null,
    panelSettingsData: null,
    globalFunctionsLoading: false,
  }),
  computed: {
    deviceAvailable() {
      return this.deviceConnected && this.deviceInfo?.state?.isOn;
    },
    curTempSign() {
      return getSignDirection(this.deviceInfo.curTemp);
    },
  },
  watch: {
    deviceInfo: {
      handler() {
        this.globalFunctionsLoading = false;
      },
      deep: true,
    },
  },
  methods: {
    applyDeviceFunction(data) {
      this.globalFunctionsLoading = true;
      this.$emit('customChange', data);
    },
    toggleControlItemContextMenu(e) {
      this.$refs.controlItemContextMenu.toggle(e);
    },
  },
};
